'use client';

import { CaseSliderCard } from '@components/casesSlider';
import { classNames } from '@lib/classNames/classNames';
import Link from 'next/link';
import { Fragment, memo, useId } from 'react';

export const CardLinkWrapper = memo(
  ({
    card,
    children,
    className,
  }: React.PropsWithChildren<{ card: CaseSliderCard; className?: string }>) => {
    const id = useId();

    return card.urlArticle ? (
      <Link
        href={card.urlArticle}
        key={id}
        className={classNames({
          cls: 'block h-full w-full',
          additional: [className],
        })}
      >
        {children}
      </Link>
    ) : (
      <Fragment key={id}>{children}</Fragment>
    );
  },
);

CardLinkWrapper.displayName = 'CardLinkWrapper';
